/*
 * @Description: 日程管理 - 日期API
 * @Author: AI Assistant
 * @Date: 2023-10-30
 */

import request from '@/utils/request'

/**
 * 获取日期列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getDateList(params) {
  return request({
    url: '/schedule/date/list',
    method: 'get',
    params
  })
}

/**
 * 添加日期
 * @param {Object} data - 日期数据
 * @returns {Promise}
 */
export function addDate(data) {
  return request({
    url: '/schedule/date/add',
    method: 'post',
    data
  })
}

/**
 * 编辑日期
 * @param {Object} data - 日期数据
 * @returns {Promise}
 */
export function editDate(data) {
  return request({
    url: '/schedule/date/edit',
    method: 'post',
    data
  })
}

/**
 * 删除日期
 * @param {Object} data - 包含id的参数对象
 * @returns {Promise}
 */
export function deleteDate(data) {
  return request({
    url: '/schedule/date/delete',
    method: 'post',
    data
  })
}

/**
 * 获取日期详情
 * @param {Object} data - 包含id的参数对象
 * @returns {Promise}
 */
export function getDateDetail(data) {
  return request({
    url: '/schedule/date/detail',
    method: 'post',
    data
  })
}

/**
 * 批量创建日期
 * @param {Object} data - 批量创建数据
 * @returns {Promise}
 */
export function batchCreateDates(data) {
  return request({
    url: '/schedule/date/batchAdd',
    method: 'post',
    data
  })
} 